import { Game } from './game.js';
import { startLoop } from './loop.js';

const game = new Game();
if (import.meta.env.DEV) globalThis.__worldCanvas = game;
game.init()
  .then(() => startLoop(game))
  .catch((error) => console.error('Failed to start World Canvas:', error));
